// Components
import "../loader/index";
import "../user-avatar/index";
import "../forms/select-single/index";
import SelectItem from "../../core/interfaces/SelectItem";

// Classes
// eslint-disable-next-line
import { Component, CustomElement } from "../../core/CustomElement";
import { CCCSelectSingle } from "../forms/select-single";
import MonthlyThemePanelVM from "./MonthlyThemePanelVM";

//utils
import { enumToSelectItem } from "../../core/utilities";
import { MonthlyThemeFilter } from "../../core/interfaces/MonthlyTheme";

export interface CCCMonthlyThemePanelState {
  startTime: string;
  minPages: number;
}

// eslint-disable-next-line
@Component("ccc-monthly-theme-panel", {
  template: require("./MonthlyThemePanelTemplate.html").default,
  style: require("./MonthlyThemePanelStyle.scss").default,
  viewModel: require("./MonthlyThemePanelVM"),
  observedAttributes: ["start-time"],
})
// eslint-disable-next-line
export class CCCMonthlyThemePanel extends CustomElement {
  state: CCCMonthlyThemePanelState = {
    startTime: "",
    minPages: 3,
  };

  viewModel: MonthlyThemePanelVM = null;
  monthSelector: CCCSelectSingle = null;
  $viewSelect: CCCSelectSingle = null;
  viewOptions: Array<SelectItem> = enumToSelectItem(MonthlyThemeFilter);
  monthChangeFnc: () => void = () => {
    console.debug("Monthly Theme Panel", "Month Changed not implemented");
  };

  connectedCallback(): void {
    console.debug("Monthly Theme Panel", "Component INIT");
    this.monthSelector = this.shadowDom.querySelector(
      "#month-selector"
    ) as CCCSelectSingle;
    this.$viewSelect = this.shadowDom.querySelector(
      "#viewSelect"
    ) as CCCSelectSingle;
    // Ensuring reactivity and correct initialization
    this.viewModel.activeTabView.subscribe((newVal) => {
      console.debug("Monthly Theme Panel", "Subscribed to active item", newVal);
      if (newVal) {
        this.$viewSelect.setValue(newVal);
      }
    });
    this.addViewModelSubs();
    this.addTabOptions();
  }

  addViewModelSubs(): void {
    this.viewModel.months.subscribe((newVal) => {
      console.debug("Monthly Theme Panel", "Subscribed to months", newVal);
      if (newVal) {
        this.monthSelector.setKeyState("options", newVal);
      }
    });
    this.viewModel.ready.subscribe((newVal) => {
      if (typeof newVal === "boolean") {
        this.loading = !newVal;
      }
    });
    this.viewModel.activeItem.subscribe((newVal) => {
      console.debug("Monthly Theme Panel", "Subscribed to active item", newVal);
      if (newVal) {
        // this.monthSelector.setValue(newVal);
        this.monthChangeFnc();
      }
    });

    setTimeout(() => {
      this.monthSelector.onItemSelect((newVal) => {
        console.debug("Monthly Theme Panel", "On Month Item Selector", newVal);
        if (newVal) {
          this.viewModel.activeItem(newVal);
        }
      });
    }, 0);
  }

  addTabOptions() {
    setTimeout(() => {
      this.$viewSelect.setKeyState("options", this.viewOptions);
    }, 0);
  }
}
